import AxiosClient from 'axios'
import routes from '@configs/api'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Link Resource with course lecture
 * @param course_id
 * @param version
 * @param sectionId
 * @param lectureId
 * @param resourceId
 * @param abortController
 */
const linkCourseLectureWithResources = (
  course_id: string,
  version: number,
  sectionId: string,
  lectureId: string,
  resourceId: string,
  abortController?: AbortController
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL =
      routes.COURSE +
      course_id +
      '/' +
      version +
      '/sections/' +
      sectionId +
      '/lectures/' +
      lectureId +
      '/resources/' +
      resourceId +
      '/link'
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
      signal: abortController?.signal,
    }

    AxiosClient.post(URL, {}, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        if (AxiosClient.isCancel(err)) {
          reject(err)
        } else {
          reject(err)
        }
      })
  })
}

export default linkCourseLectureWithResources
